import { render, staticRenderFns } from "./AppointmentsGrid.vue?vue&type=template&id=5aa69a48"
import script from "./AppointmentsGrid.vue?vue&type=script&lang=js"
export * from "./AppointmentsGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports